import axios from "axios";

const API_URL = "https://admin.defconinnovations.com/api"; // Your Django API URL

// Function to log in and obtain JWT tokens
export const loginWithCredentials = async (username, password) => {
  try {
    const response = await axios.post(
      `${API_URL}/sso/`,
      { username, password },
      {
        withCredentials: true, // Important: Allow cookies to be sent/received
      }
    );
    localStorage.setItem("access_token", response.data.access); // Store access token
    return response.data;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

// Function to refresh the access token using the refresh token stored in cookies
export const refreshAccessToken = async () => {
  try {
    //     const accessToken = localStorage.getItem('access_token');
    //   if (!accessToken) {
    //     throw new Error('No access token available');
    //   }
    const response = await axios.post(
      `${API_URL}/customrefresh/`,
      {},
      {
        withCredentials: true, // Allow cookies (the refresh token is sent automatically)
      }
    );
    localStorage.setItem("access_token", response.data.access); // Update access token
    return response.data.access;
  } catch (error) {
    console.error("Error refreshing access token:", error);
    throw error;
  }
};

// Function to get user info (protected endpoint)
export const getUserInfo = async () => {
  const accessToken = localStorage.getItem("access_token");
  //   if (!accessToken) {
  //     throw new Error('No access token available');
  //   }

  try {
    const response = await axios.get(`${API_URL}/validate-token/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (error) {
    // Handle token expiration here
    if (error.response && error.response.status === 401) {
      // Access token might have expired, try to refresh it
      console.log("trying refresh");
      await refreshAccessToken();
      return await getUserInfo(); // Retry after refreshing token
    }
    console.error("Error fetching user info:", error);
    throw error;
  }
};
// Function to logout
export const signoff = async () => {
  try {
    //     const accessToken = localStorage.getItem('access_token');
    //   if (!accessToken) {
    //     throw new Error('No access token available');
    //   }
    const response = await axios.post(
      `${API_URL}/logout/`,
      {},
      {
        withCredentials: true, // Allow cookies (the refresh token is sent automatically)
      }
    );
  } catch (error) {
    console.error("Error logout:", error);
    throw error;
  }
};
